module.exports = __webpack_public_path__ + "img/product_101.7d8abc9.webp";